import { render, staticRenderFns } from "./WhySiteMapPage.vue?vue&type=template&id=66ea4fe7&scoped=true"
import script from "./WhySiteMapPage.vue?vue&type=script&lang=js"
export * from "./WhySiteMapPage.vue?vue&type=script&lang=js"
import style0 from "./WhySiteMapPage.vue?vue&type=style&index=0&id=66ea4fe7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea4fe7",
  null
  
)

export default component.exports